/* Observe accepted Shopify AJAX additions; never modify or repeat cart requests. */
(function (w, d) {
  'use strict';
  if (w.__ukCartSuccessTracking) return;
  w.__ukCartSuccessTracking = true;
  var completed = Object.create(null);
  var completedKeys = [];
  var sequence = 0;

  function cartAdd(input, method) {
    try {
      var url = new URL(typeof input === 'string' ? input : input.url || String(input), w.location.href);
      return String(method || 'GET').toUpperCase() === 'POST' &&
        url.origin === w.location.origin && /\/cart\/add(?:\.js)?\/?$/.test(url.pathname);
    } catch (_) { return false; }
  }

  function requestItems(body) {
    try {
      var payload = body;
      if (typeof body === 'string') {
        try { payload = JSON.parse(body); }
        catch (_) { payload = new URLSearchParams(body); }
      }
      if (payload && typeof payload.entries === 'function') {
        var flat = {}, indexed = {};
        payload.forEach(function (value, key) {
          var match = /^items\[(\d+)\]\[(id|quantity)\]$/.exec(key);
          if (match) {
            indexed[match[1]] = indexed[match[1]] || {};
            indexed[match[1]][match[2]] = value;
          } else if (key === 'id' || key === 'quantity') { flat[key] = value; }
        });
        payload = Object.keys(indexed).length ? { items: Object.keys(indexed).map(function (key) { return indexed[key]; }) } : flat;
      }
      var items = payload && Array.isArray(payload.items) ? payload.items : [payload];
      return items.filter(function (item) { return item && /^\d+$/.test(String(item.id)); }).map(function (item) {
        return { id: String(item.id), quantity: item.quantity == null ? 1 : Number(item.quantity) };
      }).filter(function (item) { return Number.isInteger(item.quantity) && item.quantity > 0; });
    } catch (_) { return []; }
  }

  function clarity(name) {
    try { if (typeof w.clarity === 'function') w.clarity('event', name); } catch (_) {}
  }

  function accepted(payload, requested, requestId) {
    try {
      if (!payload || payload.status || payload.errors || !requested.length) return;
      // A repeated load callback or fetch/XHR observer must not emit the same request twice.
      if (requestId && completed[requestId]) return;
      var returned = Array.isArray(payload.items) ? payload.items : [payload];
      var used = Object.create(null);
      var items = returned.map(function (line) {
        var variant = String(line.variant_id || line.id || '');
        // Match each requested entry once: quantities in a response can be the cumulative cart quantity.
        var match = -1;
        requested.some(function (item, index) {
          if (!used[index] && item.id === variant) { match = index; return true; }
          return false;
        });
        if (match < 0 || !/^\d+$/.test(String(line.product_id)) || !Number.isFinite(Number(line.price))) return null;
        used[match] = true;
        return {
          id: 'shopify_GB_' + line.product_id + '_' + variant,
          item_id: 'shopify_GB_' + line.product_id + '_' + variant,
          item_variant: variant,
          item_name: String(line.product_title || line.title || ''),
          item_brand: String(line.vendor || ''),
          price: Number(line.final_price == null ? line.price : line.final_price) / 100,
          quantity: requested[match].quantity
        };
      }).filter(Boolean);
      if (!items.length) return;
      if (requestId) {
        completed[requestId] = true;
        completedKeys.push(requestId);
        if (completedKeys.length > 100) delete completed[completedKeys.shift()];
      }
      w.dataLayer = w.dataLayer || [];
      w.dataLayer.push({
        event: 'dl_add_to_cart',
        event_id: requestId || 'uk-cart-' + Date.now() + '-' + (++sequence),
        ecommerce: {
          currency: w.Shopify && w.Shopify.currency && w.Shopify.currency.active || 'GBP',
          value: items.reduce(function (value, item) { return value + item.price * item.quantity; }, 0),
          items: items
        }
      });
      // No artwork, uploaded-photo URLs, names entered by customers or line properties are transmitted.
      clarity('bl_cart_add_success');
    } catch (_) { /* Analytics must never interrupt a successful purchase flow. */ }
  }

  var originalFetch = w.fetch;
  if (typeof originalFetch === 'function') {
    w.fetch = function (input, init) {
      var eligible = cartAdd(input, init && init.method || input && input.method);
      var requested = eligible ? requestItems(init && init.body) : [];
      var pending = originalFetch.apply(this, arguments);
      if (!eligible || !requested.length) return pending;
      return pending.then(function (response) {
        if (!response.ok) return response;
        try {
          var requestId = response.headers.get('x-request-id');
          return response.clone().json().then(function (payload) {
            accepted(payload, requested, requestId);
            return response;
          }, function () { return response; });
        } catch (_) { return response; }
      });
    };
  }

  var XHR = w.XMLHttpRequest;
  if (XHR && XHR.prototype) {
    var open = XHR.prototype.open;
    var send = XHR.prototype.send;
    var requests = new WeakMap();
    XHR.prototype.open = function (method, url) {
      requests.set(this, { eligible: cartAdd(url, method) });
      return open.apply(this, arguments);
    };
    XHR.prototype.send = function (body) {
      var xhr = this;
      var state = requests.get(xhr);
      if (state && state.eligible) {
        var requested = requestItems(body);
        var done = false;
        var onLoad = function () {
          xhr.removeEventListener('load', onLoad);
          if (done || xhr.status < 200 || xhr.status >= 300) return;
          done = true;
          try {
            var payload = xhr.responseType === 'json' ? xhr.response : JSON.parse(xhr.responseText);
            accepted(payload, requested, xhr.getResponseHeader('x-request-id'));
          } catch (_) {}
        };
        xhr.addEventListener('load', onLoad);
      }
      return send.apply(this, arguments);
    };
  }

  function pageEvents() {
    if (/\/cart\/?$/.test(w.location.pathname)) clarity('bl_cart_view');
    d.addEventListener('click', function (event) {
      var target = event.target && event.target.closest && event.target.closest('button[name="checkout"],input[name="checkout"],.cart__checkout,a[href*="/checkout"]');
      if (!target || target.disabled || target.getAttribute('aria-disabled') === 'true') return;
      clarity('bl_checkout_intent');
    }, true);
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', pageEvents, { once: true });
  else pageEvents();
})(window, document);
